import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id", "draggable"]

export interface propsComponent {
  isPreview: boolean;
}
import { useAttrs, ref, watchEffect, withDefaults } from "vue";

import { defineComponent, computed } from "vue";
import { getLookups } from "@/services/api/Lookup.service";
const __default__ = defineComponent({
  name: "LKLookup",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isPreview: boolean }


const attrs = useAttrs();
const lookupModel = ref("");
const LKLookupOptions = ref<{ label: any; value: string }[]>([]);
const style = computed(() => {
  return !props.isPreview ? "pointer-events: none" : "";
});
const restAttr = computed(() => {
  const { id, ...rest } = attrs;

  return rest;
});
const isDraggable = computed(() => {
  return attrs?.draggable ?? false;
});
const fetchLookupOptions = async () => {
  const lookupURL = `static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=${attrs.label}`;
  getLookups(lookupURL)
    .then((res) => {
      if (res) {
        const lookupOptions = res.map((item) => {
          return {
            label: item.text,
            value: item.value,
          };
        });
        LKLookupOptions.value = lookupOptions;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

watchEffect(() => {
  LKLookupOptions.value = [];
  if (attrs.name) {
    fetchLookupOptions();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "VZ_TABLE_INPUT",
    id: _unref(attrs).id,
    draggable: _unref(isDraggable)
  }, [
    _createVNode(_component_el_select, {
      clearable: "",
      filterable: true,
      modelValue: lookupModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lookupModel).value = $event)),
      style: _normalizeStyle(_unref(style))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(LKLookupOptions.value, (option, index) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: option.label,
            value: option.label
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "style"])
  ], 8, _hoisted_1))
}
}

})